<div class="table">
    <geaui-table-v2 class="overview-table" #table [data]="tableData" [columnDefinitions]="columns"
        [loading]="contentReady"></geaui-table-v2>
</div>